import { Pessoa, PessoaEndereco } from '@tivic-team/manager-ts/dist/grl';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { GrupoParada } from '@tivic-team/manager-ts/dist/mob/entities/parada/grupo-parada.entity';
import { Parada } from '@tivic-team/manager-ts/dist/mob/entities/parada/parada.entity';

export class ConcessaoTaxiDTO {

    concessao: Concessao = void(0);
    pessoa: Pessoa = void(0);
    parada: Parada = void(0);
    pessoaEndereco: PessoaEndereco = void(0);
    grupoParada: GrupoParada = void(0);
    lgCnhPermissionario: number;
    lgHabilitacaoAuxiliar: number;
    lgTaximetro: number;
    lgCrlv: number;
    nrPlaca: string;

    constructor() {}
}